import gql from 'graphql-tag';

const GET_JOB_DETAILS = gql`
  query getSegmentationJobDetails(
    $seoSegmentId: ID!
    $isSeniorCare: Boolean!
    $isChildCare: Boolean!
    $isPetCare: Boolean!
    $isHousekeeping: Boolean!
    $isTutoring: Boolean!
  ) {
    getSEOSegmentationBreadcrumbs(seoSegmentId: $seoSegmentId) {
      breadcrumbs {
        content
        url
      }
    }
    getSEOSegmentationJobDetails(seoSegmentId: $seoSegmentId) {
      seoSegmentationJob {
        job {
          title
          id
          startDate
          serviceType
          hourlyRateRange {
            hourlyRateFrom {
              amount
              currencyCode
            }
            hourlyRateTo {
              amount
              currencyCode
            }
          }
        }
        city
        state
        seekerAvatar
        description
        type
        schedule
        serviceId
        serviceIdForMember
        jobPreferences {
          ... on SeniorCareJobPreferences @include(if: $isSeniorCare) {
            assistsMobility
            caresForWounds
            doesBathing
            doesCompanionship
            doesFeeding
            doesHeavyLifting
            doesLightHousekeeping
            doesNotSmoke
            helpsStayingActive
            isComfortableWithPets
            ownsTransportation
            prepsMeals
            promptsMedication
            runsErrands
            transports
          }
          ... on ChildCareJobPreferences @include(if: $isChildCare) {
            additionalDetails
            doesHomeworkHelp
            doesLaundry
            doesLightHousekeeping
            doesNotSmoke
            dropPickupChildren
            isComfortableWithPets
            ownsTransportation
            prepsMeals
            runsErrands
          }
          ... on PetCareJobPreferences @include(if: $isPetCare) {
            additionalDetails
            doeOvernightCare
            doesBoarding
            doesFeeding
            doesGrooming
            doesMedicineAdministration
            doesNotSmoke
            doesPlayAndExercise
            doesTraining
            doesWalking
            doesWasteCleanup
            ownsTransportation
          }
          ... on HousekeepingJobPreferences @include(if: $isHousekeeping) {
            frequency
            homeSize {
              numberOfBathrooms
              numberOfBedrooms
            }
            isComfortableWithPets
            ownsTransportation
            providesEquipment
            providesSupplies
            servicesNeeded
          }
          ... on TutoringJobPreferences @include(if: $isTutoring) {
            doesNotSmoke
            educationLevel
            isComfortableWithPets
            ownsTransportation
            subjectAreas
          }
        }
      }

      nearbyJobs {
        job {
          title
          startDate
        }
        city
        seekerAvatar
        url
      }

      pageMetadata {
        indexable
        canonicalURL
        title
        metaDescriptions
        metaKeywords
      }
      googleRichCardStructuredJson
    }
  }
`;

export default GET_JOB_DETAILS;
